import cls from "./customInnerPage.module.scss";
import {CustomSelectArrow} from "../../../svg";
import React, {Dispatch, FC, MutableRefObject, ReactNode, SetStateAction, useEffect, useState} from "react";
import {IProduct, IProductOption, TranslationsType} from "../../../types/homePageTypes";
import {useDispatch, useSelector} from "react-redux";
import {setCustomOptionOpenAction, setOptionValuesAction} from "../../../store/product";
import {IState} from "../../../types/state";
import useDebounce from "../../../hooks/useDebounce";

interface ICustomProducts {
    productOptions?: Array<IProductOption>;
    translationsData: TranslationsType;
    refsMap?: MutableRefObject<Map<number, HTMLDivElement>>;
    product: IProduct
}

const CustomProductOptions: FC<ICustomProducts> = (
    {
        product,
        productOptions,
        translationsData,
        refsMap,
    }
) => {
    const dispatch = useDispatch();
    const customOptionOpen = useSelector((state: IState) => state.product.customOptionOpen);
    const optionValues = useSelector(((state: IState) => state.product.optionValues));
    const notFilledOptions = useSelector(((state: IState) => state.product.notFilledOptions));
    const [selectedId, setSelectedId] = useState<number | null>(null);
    useEffect(() => {
        if (customOptionOpen.length > 0) {
            const handleClickOutside = (event: MouseEvent) => {
                let clickedInside = false;
                refsMap?.current.forEach((ref) => {
                    if (ref.contains(event.target as Node)) clickedInside = true;
                });
                if (!clickedInside) {
                    dispatch(setCustomOptionOpenAction({isOutsideClick: true, optionId: 0}));
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [customOptionOpen.length]);
    const optionIdShowToggle = (elemId: number) => {
        const foundOption = optionValues?.find((item) => item?.id === elemId);
        if (foundOption) return foundOption?.label
    }
    const Select = ({ option }: { option: IProductOption }) => {
        const required = notFilledOptions?.some((item) => item === option?.id);
        const findItem = customOptionOpen.some((item) => item === option.id);
        return (
            <div className={cls.select__option} key={option.id}>
                <span className={cls.option_title}>{option?.title}</span>
                {Number(option?.required) ? <span style={{color: "red"}}> *</span> : null}
                <div ref={(el) => {
                    if (el) refsMap?.current.set(option.id, el);
                }}>
                    <div className={cls["option_label"]}
                         style={required ? {border: "1px solid red"} : {}}>
                        <div
                            className={cls["dropdown_btn"]}
                            onClick={() => dispatch(setCustomOptionOpenAction({optionId: option.id}))}
                        >
                            <span
                                className={cls.selected__option}>{optionIdShowToggle(option!.id) || translationsData.Select}</span>
                            <CustomSelectArrow
                                className={`${cls.drop_down_arrow} ${cls[findItem ? "drop_down_opened" : ""]}`}/>
                        </div>
                    </div>
                    <div
                        style={{display: findItem ? "block" : "none"}}
                        className={cls.options_dropdown}
                    >
                        {option?.children?.map((item: any) => (
                            <div
                                className={`${cls.option_dropdown_value} ${selectedId === item.id ? cls.selected : ""}`}
                                key={item.id}
                                onClick={() => {
                                    setSelectedId(item.id);
                                    dispatch(setOptionValuesAction({
                                        id: option!.id,
                                        label: item.label,
                                        price: String(item.price),
                                        optionId: item.id,
                                        type: option?.type
                                    }));
                                    dispatch(setCustomOptionOpenAction({optionId: option.id}))
                                }}
                            >
                                <label htmlFor={item.admin_name}>{item.label}</label>
                            </div>
                        ))}
                    </div>
                </div>
                {required ? (
                    <div className={cls["err-block"]}>
                        {translationsData?.RequiredField}
                    </div>
                ) : null}
            </div>
        )
    }
    const text = ({ option }: { option: IProductOption }) => {
        const required = notFilledOptions?.some((item) => item === option?.id);
        return <div className={cls.text__option}>
                <span className={cls.option_title}>{option?.title}
                    {Number(option?.required) ? <span style={{color: "red"}}> *</span> : null}
                    {product?.attribute_family?.code === "Donation" ? "" : " + " + option?.price}
                </span>
            <textarea
                name="forTextOption"
                className={cls["auto-expand"]}
                onInput={(e: any) => {
                    e.target.style.height = "50px";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                maxLength={Number(option?.max_characters)}
                onChange={(e) => {
                    const targetValue = product?.attribute_family?.code === "Donation"
                    ? e.target.value.replace(/\D/g, "")
                    : e.target.value;
                    e.target.value = targetValue
                    const actionAttrs = {
                        id: option!.id,
                        label: targetValue,
                        price: String(option?.price),
                        optionId: targetValue,
                        type: option?.type
                    }
                    if (targetValue) {
                        dispatch(setOptionValuesAction(actionAttrs));
                    } else {
                        dispatch(setOptionValuesAction({isFiltered: true, ...actionAttrs}));
                    }
                }}
                style={required ? {border: "1px solid red"} : {}}
            ></textarea>
            {required ? (
                <div className={cls["err-block"]}>
                    {translationsData?.RequiredField}
                </div>
            ) : null}
        </div>
    }

    return (
        <div className={cls["configurable-attributes"]}>
            {productOptions?.map((option, index) => {
                if (option?.type === "select") {
                    return <div className={cls["each__option"]} key={index}>
                        <Select option={option} />
                    </div>
                } else if (option?.type === "text") {
                    return <div className={cls["each__option"]} key={index}>
                        {text({option})}
                    </div>
                }
                return null;
            })}
        </div>
    )
};

export default CustomProductOptions
